<template>
    <div class="st">
        <v-container fluid class="st-wrap pa-0" v-if="store">

        <!-- ENCABEZADO DEL COMERCIO -->
        <header class="st-head">
            <div class="st-cover">
                <img v-if="coverImg" :src="coverImg" alt="" fetchpriority="high">
                <span class="st-cover-shade"></span>
            </div>
            <div class="st-id">
                <div class="st-logo">
                    <img v-if="store.attributes.logoUrl" id="logoStore" ref="logoStore" :src="store.attributes.logoUrl" :alt="`Logo de ${store.attributes.name}`">
                    <span v-else aria-hidden="true">{{ store.attributes.name.charAt(0) }}</span>
                </div>
                <div class="st-id-t">
                    <h1 class="st-name" translate="no">{{ store.attributes.name }}</h1>
                    <div class="st-meta">
                        <span class="st-state" :class="store.attributes.status == 'active' ? 'open' : 'closed'">
                            <i></i>{{ store.attributes.status == 'active' ? 'Abierto' : 'Cerrado' }}
                        </span>
                        <span v-if="store.attributes.delivery && store.attributes.delivery.timeCaption" class="st-pill"><v-icon x-small>mdi-bike</v-icon> {{ store.attributes.delivery.timeCaption }}</span>
                        <button v-if="store.attributes.rating" type="button" class="st-pill btn" @click="dialogStoreReview = true"><v-icon x-small color="#f59e0b">mdi-star</v-icon> {{ store.attributes.rating }}</button>
                        <button v-if="store.attributes.description" type="button" class="st-pill btn" @click="dialogDescriptionStore = true"><v-icon x-small>mdi-information-outline</v-icon> Saber más</button>
                    </div>
                    <p class="st-addr"><v-icon x-small>mdi-map-marker-outline</v-icon> {{ store.attributes.address }}<span v-if="store.attributes.city">, {{ store.attributes.city }}</span></p>
                    <p v-if="store.attributes.acceptBankTransfer" class="st-addr"><v-icon x-small>mdi-wallet-outline</v-icon> Pagos: Efectivo, {{ getStringTransferMethods(store.attributes.transfersMethods) }}</p>
                </div>
            </div>
        </header>

        <!-- PESTAÑAS -->
        <nav v-if="groups.length > 1" class="st-tabs" aria-label="Secciones del menú">
            <div class="st-tabs-in">
                <button v-for="g in groups" :key="g.key" type="button" class="st-tab" :class="{ on: activeGroup === g.key }" :aria-pressed="activeGroup === g.key ? 'true' : 'false'" @click="goGroup(g.key)">
                    {{ g.label }} <span class="st-n">{{ g.count }}</span>
                </button>
            </div>
        </nav>

        <div v-if="loading" class="st-body" aria-busy="true">
            <div class="st-grid"><div v-for="n in 4" :key="n" class="st-skel"></div></div>
        </div>

        <main v-else class="st-body">
            <section v-for="g in groups" :key="g.key" :id="`st-${g.key}`" class="st-group" :aria-label="g.label">
                <div class="st-group-head">
                    <h2>{{ g.label }}</h2>
                    <span v-if="g.key === 'bebidas'" class="st-note">Imágenes de referencia</span>
                </div>

                <!-- DESTACADOS CON IMAGEN -->
                <div v-if="g.featured.length" class="st-grid">
                    <article v-for="p in g.featured" :key="p.id" class="st-card">
                        <div class="st-card-img">
                            <img :src="p.attributes.imageUrl" :alt="p.attributes.name" loading="lazy" decoding="async">
                            <span v-if="p.attributes.exclusive" class="st-excl">Exclusivo</span>
                        </div>
                        <div class="st-card-b">
                            <span class="st-eyebrow">{{ p._section }}</span>
                            <button type="button" class="st-card-n" translate="no" @click="openDialogAddItem(p)">{{ p.attributes.name }}</button>
                            <p v-if="p.attributes.description" class="st-desc">{{ p.attributes.description }}</p>
                            <div class="st-card-f">
                                <span class="st-price">
                                    {{ (p.attributes.newPrice ? p.attributes.newPrice : p.attributes.price) | currency }}
                                    <s v-if="p.attributes.newPrice">{{ p.attributes.price | currency }}</s>
                                </span>
                                <button type="button" class="st-add gold" :aria-label="`Agregar ${p.attributes.name}`" @click="openDialogAddItem(p)">+</button>
                            </div>
                        </div>
                    </article>
                </div>

                <!-- RESTO, EN FILAS COMPACTAS -->
                <div v-for="s in g.plainSections" :key="s.name" class="st-sub">
                    <h3 v-if="g.plainSections.length > 1 || g.featured.length">{{ s.name }}</h3>
                    <div class="st-rows">
                        <div v-for="p in s.items" :key="p.id" class="st-row" :class="{ drink: g.key === 'bebidas' }">
                            <div v-if="g.key === 'bebidas'" class="st-thumb"><drink-art :name="p.attributes.name"></drink-art></div>
                            <div class="st-row-t">
                                <button type="button" class="st-row-n" translate="no" @click="openDialogAddItem(p)">{{ p.attributes.name }}</button>
                                <p v-if="p.attributes.description" class="st-desc one">{{ p.attributes.description }}</p>
                            </div>
                            <span class="st-price">
                                {{ (p.attributes.newPrice ? p.attributes.newPrice : p.attributes.price) | currency }}
                                <s v-if="p.attributes.newPrice">{{ p.attributes.price | currency }}</s>
                            </span>
                            <button type="button" class="st-add" :aria-label="`Agregar ${p.attributes.name}`" @click="openDialogAddItem(p)">+</button>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <v-dialog
            v-model="dialogAddItems"
            max-width="600"
            scrollable
            v-if="promotion"
            :no-click-animation="true"
        >
        <v-card class="mx-auto">

            <v-card-title class="subtitle-1 d-inline-block text-truncate pb-1">
            <v-btn class="float-right" icon @click="dialogAddItems = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            {{ promotion.attributes.name }}
            </v-card-title>

            <v-card-subtitle class="subtitle-2 pb-2">
            {{ promotion.attributes.store.attributes.name }}
            </v-card-subtitle>

            <v-img
                aspect-ratio="1.7778"
                v-if="promotion.attributes.imageUrl"
                :lazy="promotion.attributes.imageUrl"
                :src="promotion.attributes.imageUrl"
            ></v-img>

            <v-card-text>
            <v-row>
                <v-col cols="7">
                <div class="headline"> {{ promotion.attributes.newPrice ? promotion.attributes.newPrice : promotion.attributes.price | currency }} </div>
                <div class="subtitle-2"> DOMICILIO: {{ promotion.attributes.deliveryCost | currency }} </div>
                </v-col>
                <v-col cols="5" style="text-align: right; padding-right: 0px;">
                    <div>
                        <div class="subtitle-2" style="margin-right: 15px;"> <v-icon>mdi-share</v-icon> Compartir </div>
                        <ShareNetwork
                            network="facebook"
                            :url="getUrlSharing(promotion.id)"
                            :title="promotion.attributes.name"
                            :description="promotion.attributes.description"
                            :quote="promotion.attributes.description"
                            hashtags="festyapp,promos,promociones"
                            style="margin-right: 10px;"
                        >
                            <v-icon style="color: #1877f2;">mdi-facebook</v-icon>
                        </ShareNetwork>

                        <ShareNetwork
                            network="twitter"
                            :url="getUrlSharing(promotion.id)"
                            :title="promotion.attributes.name"
                            :description="promotion.attributes.description"
                            :quote="promotion.attributes.description"
                            hashtags="festyapp,promos,promociones"
                            style="margin-right: 10px;"
                        >
                            <v-icon style="color: #1da1f2;">mdi-twitter</v-icon>
                        </ShareNetwork>

                        <ShareNetwork
                            network="whatsapp"
                            :url="getUrlSharing(promotion.id)"
                            :title="promotion.attributes.name"
                            :description="promotion.attributes.description"
                            :quote="promotion.attributes.description"
                            hashtags="festyapp,promos,promociones"
                            style="margin-right: 10px;"
                        >
                            <v-icon style="color: #25d366;">mdi-whatsapp</v-icon>
                        </ShareNetwork>

                    </div>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0">
                {{ promotion.attributes.description }}
                </v-col>

                <v-col cols="12" class="pt-0 pb-0" v-if="promotion.attributes.modifiers && promotion.attributes.modifiers.length > 0">
                    <v-row>
                    <v-col cols="12" v-for="(item, index) in promotion.attributes.modifiers" :key="index">
                        <div class="body-1"> <strong>{{ item.title }}</strong> <span class="caption info--text font-weight-bold">{{ item.mandatory ? '(modificador obligatorio)' : '' }}</span> </div>
                        <div class="body-1 ma-0 pa-0" v-if="!item.multiple">
                        <v-radio-group v-model="itemsBox[item.title]" hide-details class="pa-1 ma-0" row>
                            <v-radio
                                v-for="(option, index2) in item.options" :key="index2"
                                :label="`${option.label}`"
                                :value="option"
                                @change="setModifiersMirrorBox(item, option)"
                            >
                            <template v-slot:label>
                                {{ option.label }} <strong class="ml-2 caption font-weight-bold"> +{{ option.price > 0 ? option.price : 0 | currency}}</strong>
                            </template>
                            </v-radio>
                        </v-radio-group>
                        </div>
                        <div class="body-1 ma-0 pa-0" justify="space-around" v-else>
                        <v-checkbox
                            class="ma-1"
                            v-for="(option, index2) in item.options" :key="index2"
                            v-model="itemsCheck"
                            hide-details
                            :value="option"
                            @change="setModifiersMirrorCheck(item)"
                            >
                            <template v-slot:label>
                            {{ option.label }} <strong class="ml-2 caption font-weight-bold"> +{{ option.price > 0 ? option.price : 0 | currency}}</strong>
                            </template>
                            </v-checkbox>
                        </div>
                    </v-col>
                    </v-row>
                </v-col>

                
            </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn tile small color="grey" text @click="removeQuantity()" :disabled="quantity <= 1">
                <v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
            </v-btn>

            <div class="pr-2 pl-2"><strong>{{ quantity }}</strong></div>

            <v-btn tile small color="grey" text @click="addQuantity()">
                <v-icon color="success">mdi-plus-circle-outline</v-icon>
            </v-btn>

            <v-btn
                color="success darken-1"
                @click="addPromoToCar()"
            >
                <v-icon>mdi-cart-plus</v-icon>
                <span class="ml-2 font-weight-bold d-flex d-md-none">Agregar</span>
            <span class="ml-2 font-weight-bold d-none d-md-flex">Agregar {{ quantity * (promotion.attributes.newPrice ? promotion.attributes.newPrice : promotion.attributes.price + selectModifiers.reduce((a, b) => { return a + b.options.reduce((c, d) => { return c + d.price}, 0) }, 0) ) | currency }}</span>
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <!-- Dialogo review store -->
        <v-dialog v-model="dialogStoreReview" width="500" scrollable>
        <v-form ref="formCancel" v-model="validCancel">
            <v-card v-if="ratings">
            <v-card-title class="subtitle-1 grey lighten-2" primary-title v-if="store.attributes.name">
                {{ store.attributes.name }} <span v-if="store.attributes.rating" class="pl-1"> ({{store.attributes.rating}})</span>
            </v-card-title>

            <v-card-text v-if="ratings && ratings.length > 0">
                <div class="mb-2"></div>
                
                <v-list three-line v-if="ratings">
                <template>
                    
                    <!--<v-subheader>
                        Premedio: XX
                    </v-subheader>-->

                    <span v-for="(item, index) in ratings" :key="index">

                    <v-divider v-if="item.rating"></v-divider>

                    <v-list-item
                    v-if="item.rating"
                    :key="index"
                    >
                    <!--<v-list-item-avatar>
                        <v-img :src="item.attributes.owner.attributes.photoUrl ? item.attributes.owner.attributes.photoUrl : require('./../assets/user.png')"></v-img>
                    </v-list-item-avatar>-->

                    <v-list-item-content>
                        <v-list-item-title class="body-2">
                            <div>{{item.alias}}</div>
                        </v-list-item-title>
                        <v-list-item-subtitle style="display: flex;">
                            <v-rating
                                :value="item.rating"
                                background-color="grey lighten-2"
                                color="yellow accent-4"
                                class="pa-0 ma-0"
                                dense
                                hover
                                size="18"
                                readonly
                            ></v-rating>
                            <span class="black--text text--lighten-2 caption ml-1">
                                ({{ item.rating }})
                            </span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                        {{ item.comments ? item.comments : 'Sin comentario.' }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                    </span>
                </template>
                </v-list>

            </v-card-text>
                
                <v-card-text v-else>
                    El comercio no tiene calificaciones aún.
                </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-btn color="primary" outlined @click="dialogStoreReview = false">
                <v-icon left>mdi-close</v-icon>Cerrar
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
            </v-card>
        </v-form>
        </v-dialog>
        <!-- *End* Dialogo review store -->

        <!-- Dialogo review store -->
        <v-dialog v-model="dialogDescriptionStore" width="400" scrollable>
        <v-form ref="formCancel" v-model="validCancel">
            <v-card>
            <v-card-title class="title" primary-title>
                Información
            </v-card-title>

            <v-card-text v-if="store.attributes.description">
                <div class="mb-2"></div>
                {{store.attributes.description}}
            </v-card-text>
                
            <v-divider></v-divider>

            <v-card-actions>
                <v-btn color="primary" outlined @click="dialogDescriptionStore = false">
                <v-icon left>mdi-close</v-icon>Cerrar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" outlined @click="dialogDescriptionStore = false, dialogStoreReview = true">
                <v-icon left>mdi-star-circle</v-icon>Comentarios
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-form>
        </v-dialog>
        <!-- *End* Dialogo review store -->

        <div class="text-center" v-if="loading">
            <v-progress-circular
            :size="70"
            color="amber"
            indeterminate
            ></v-progress-circular>
        </div>

        <!-- BARRA DEL PEDIDO -->
        <div v-if="cartInfo.count > 0" class="st-cartbar-wrap" role="status">
            <div class="st-cartbar">
                <div class="st-cartbar-t">
                    <div class="st-cartbar-n">{{ cartInfo.storeName }}</div>
                    <div class="st-cartbar-d">{{ cartInfo.count }} {{ cartInfo.count === 1 ? 'producto' : 'productos' }}</div>
                </div>
                <strong class="st-cartbar-p">{{ cartInfo.total | currency }}</strong>
                <button type="button" class="st-cartbar-b" :aria-label="`Pedir en ${cartInfo.storeName}`" @click="openCart">Pedir</button>
            </div>
        </div>

        </v-container>

        <h1 v-else-if="!loading" class="text-center pt-5">No encontramos el comercio que buscas. 😬</h1>
        
    </div>
</template>

<script>
import Parse from 'parse'
import DrinkArt from '../components/DrinkArt.vue'
//import Vibrant from 'node-vibrant'

const kindOf = (name) => /bebida|licor|c[oó]ctel|cocktel|cerveza|vino|cafeter/i.test(name) ? 'bebidas' : /(^|\s)(acompa|adicion|mazorca|papas|salsa|porci)/i.test(name) ? 'acompanantes' : 'menu'
const LABELS = { menu: 'Menú', acompanantes: 'Acompañantes', bebidas: 'Bebidas' }

export default {
    components: { DrinkArt },

    metaInfo() {
        return {
            meta: this.meta
        }
    },

    data() {
        return {
            store: '',
            loading: true,
            meta: [],
            description: '',
            descriptionComplete: false,
            dialogAddItems: false,
            promotion: '',
            quantity: 1,
            modifiers: '',
            comboOption: '',
            comboPrice: '',
            selectModifiers: [],
            itemsBox: [],
            itemsCheck: [],
            categories: [],
            activeGroup: 'menu',
            background: '',
            colorText: '',
            colorTextTitle: '',
            dialogStoreReview: false,
            validCancel: false,
            ratings: [],
            dialogDescriptionStore: false
        }
    },

    computed: {
        groups() {
            const sections = (this.$store.state.products || []).filter(s => s.attributes && s.attributes.products && s.attributes.products.length)
            const out = {}
            sections.forEach(sec => {
                const key = kindOf(sec.attributes.name || '')
                const g = out[key] || (out[key] = { key, label: LABELS[key], featured: [], plainSections: [], count: 0 })
                const plain = []
                sec.attributes.products.forEach(p => {
                    const item = { id: p.id, attributes: p.attributes, _section: sec.attributes.name }
                    g.count++
                    if (p.attributes.imageUrl) g.featured.push(item); else plain.push(item)
                })
                if (plain.length) g.plainSections.push({ name: sec.attributes.name, items: plain })
            })
            return ['menu', 'acompanantes', 'bebidas'].filter(k => out[k]).map(k => out[k])
        },
        coverImg() {
            const a = this.store && this.store.attributes
            if (!a) return ''
            if (a.coverUrl) return a.coverUrl
            if (a.bannerUrl) return a.bannerUrl
            const g = this.groups.find(x => x.featured.length)
            return g ? g.featured[0].attributes.imageUrl : ''
        },
        cartInfo() {
            const cart = this.$store.state.cart || []
            let count = 0, total = 0
            cart.forEach(i => { count += i.quantity; total += (i.price + (i.modifiersPrice || 0)) * i.quantity })
            return { count, total, storeName: cart.length ? cart[0].storeName : '' }
        }
    },

    async mounted() {
        window.addEventListener('scroll', this.onScroll, { passive: true })
        this.$store.state.searchProductBox = true
        await this.initialize();
        if (window.festyTrack && this.store) window.festyTrack('view_store', { store_id: this.store.id, store_name: this.store.attributes.name })
        await this.getProducts();
        await this.getStoreReviewsList()
        
        this.meta = [
            {
                vmid: this.store ? this.store.attributes.description : '',
                name: this.store ? this.store.attributes.name : '',
                content: this.store ? this.store.attributes.description : ''
            }
        ]

        if (this.$route.query.id) {
            this.openModalProductById(this.$route.query.id)
        }
        //window.hj('stateChange', this.$route.path)
        
    },

    beforeDestroy(){
        window.removeEventListener('scroll', this.onScroll)
        this.$store.state.searchProductBox = false
    },

    methods: {
        goGroup(key) {
            this.activeGroup = key
            const el = document.getElementById('st-' + key)
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        },

        onScroll() {
            let cur = this.groups.length ? this.groups[0].key : 'menu'
            this.groups.forEach(g => {
                const el = document.getElementById('st-' + g.key)
                if (el && el.getBoundingClientRect().top <= 170) cur = g.key
            })
            if (cur !== this.activeGroup) this.activeGroup = cur
        },

        openCart() {
            if (!Parse.User.current()) {
                this.$router.push('/login')
                return
            }
            this.$store.state.cartModelNavigation = true
        },

        async initialize () {
            let params = {
                id: this.$route.params.store_id
            }
            try {
                let store = await Parse.Cloud.run("getPublicStoreBO", params);
                this.store = store[0]
                //eslint-disable-next-line
                //console.log(store);
                //this.loading = false
                this.addViewToStore(this.store)
                //this.setColorProfilePage(this.store.attributes.logoUrl);
            
            } catch (error) {
                this.$snotify.error(`${error}` , 'Comercio', {
                    timeout: 4000,
                    preventDuplicates: true
                });
            }
            
        },

        async getProducts () {
            
            this.loading = true

            let params = {
                id: this.$route.params.store_id,
                storeId: this.store.id
            }
            try {
                let products = await Parse.Cloud.run("getStoreProducts", params);
                //let products = await Parse.Cloud.run("getPublicProductsBO", params);
                this.$store.commit("setProducts", products);
                this.$store.commit("setAllProducts", products);
                
                //eslint-disable-next-line
                //console.log(this.$store.state.all_products);
                this.getCategoriesPromos()
                this.loading = false
               
            } catch (error) {
                this.$snotify.error(`${error}` , 'Productos', {
                    timeout: 4000,
                    preventDuplicates: true
                });
            }
            
        },

        async getStoreReviewsList () {

            let params = {
                storeId: this.store.id
            }
            try {
                let ratings = await Parse.Cloud.run("getStoreReviewsList", params);
                this.ratings = ratings
                //eslint-disable-next-line
                //console.log(ratings);
               
            } catch (error) {
                this.$snotify.error(`${error}` , 'Calificaciones', {
                    timeout: 4000,
                    preventDuplicates: true
                });
            }
            
        },

        async addViewToStore(store){
            try {
                const params = {
                    storeId: store.id
                };
                await Parse.Cloud.run("viewStore", params);
            
            } catch (error) {
                //eslint-disable-next-line
                console.log(error);
            }
        },

        readMore(){
            this.descriptionComplete = !this.descriptionComplete
        },

        getStringTransferMethods(methods){
            if (methods && methods.length > 0) { 
                let string_methods = ''   
                for (let index = 0; index < methods.length; index++) {
                    const element = methods[index];
                    string_methods += element.name

                    if (index < methods.length - 1) {
                        string_methods += ', '
                    }
                }

                return string_methods
            }
        },

        setModifiersMirrorCheck(item){
            //eslint-disable-next-line
            //console.log(this.itemsCheck);

            var cleanOptions = item.options.filter((word) => this.itemsCheck.includes(word));
            //console.log(cleanOptions);

            if (cleanOptions.length <= 0) {
                let index = this.selectModifiers.findIndex((element) => item.title === element.title )
                this.selectModifiers.splice(index, 1)
                return;
            }

            let newItem = {
                mandatory: item.mandatory,
                multiple: item.multiple,
                options: cleanOptions,
                title: item.title
            }
            let checkItem = this.selectModifiers.find((element) => item.title === element.title )
            if (checkItem) {
                let index = this.selectModifiers.findIndex((element) => item.title === element.title )
                this.selectModifiers[index] = newItem
            }else{
                this.selectModifiers.push(newItem) 
            }

            //eslint-disable-next-line
            //console.log(this.selectModifiers);
        },

        setModifiersMirrorBox(item, option){ 
            let newItem = {
                mandatory: item.mandatory,
                multiple: item.multiple,
                options: [option],
                title: item.title
            }
            let checkItem = this.selectModifiers.find((element) => item.title === element.title )
            if (checkItem) {
                let index = this.selectModifiers.findIndex((element) => item.title === element.title )
                this.selectModifiers[index] = newItem
            }else{
                this.selectModifiers.push(newItem) 
            }

            //eslint-disable-next-line
            //console.log(this.selectModifiers);
        },

        getBreakPointCol(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 2
                case 'sm': return 3
                case 'md': return 3
                case 'lg': return 3
                case 'xl': return 3
            }
        },

         openDialogAddItem(promo){
            //eslint-disable-next-line
            this.promotion = ''
            this.promotion = promo
            this.quantity = 1
            this.modifiers = ''
            this.comboOption = ''
            this.comboPrice = ''
            this.dialogAddItems = true
            this.selectModifiers = []
            this.itemsCheck = []
            this.itemsBox = []
        },

        addQuantity(){
            this.quantity = this.quantity+1
        },

        removeQuantity(){
            if (this.quantity > 1) {
                this.quantity = this.quantity-1
            }
        },

        addPromoToCar(){

            if(!Parse.User.current()){
                this.$router.push('/login')
                return;
            }

            if (!window.localStorage){
                this.$snotify.error('Su navegador no soporta el almacenamiento local.' , 'LocalStorage', {
                timeout: 4000,
                preventDuplicates: true
                });
                return;
            }

            if (this.$store.state.cart && this.$store.state.cart.length > 0) {
                if (this.$store.state.cart[0].store !== this.promotion.attributes.store.id) {
                this.$swal('Multiples comercios', `Ya tienes productos de ${this.$store.state.cart[0].storeName} en el carrito de compras, primero debes finalizar tu pedido con ellos para agregar productos de otro comercio.`, 'info');
                return;
                } 
            }

            if (this.promotion.attributes.modifiers && this.promotion.attributes.modifiers.length > 0) {
                let self = this
                let cleanOptions = this.promotion.attributes.modifiers.filter((o1) => {
                if(o1.mandatory){
                    return !self.selectModifiers || self.selectModifiers.length <= 0 || !self.selectModifiers.find((element) => o1.title === element.title )
                }
                }, self);

                if (cleanOptions.length > 0) {
                this.$snotify.html(`<div class="snotifyToast__title"><b>Modificadores</b></div><div class="snotifyToast__body">Seleccione los modificadores <strong>${cleanOptions.map(u => u.title).join(', ')}</strong> del producto para poder agregarlo al carrito</div><div class="snotify-icon snotify-icon--info"></div>`, {
                    timeout: 7000,
                    preventDuplicates: true,
                    type: 'info'
                });
                return;
                }
            
            }
            
            let cartItem = {
                product: this.promotion.id,
                quantity: this.quantity,
                price: this.promotion.attributes.newPrice ? this.promotion.attributes.newPrice : this.promotion.attributes.price,
                name: this.promotion.attributes.name,
                withCombo: false, //this.comboOption
                comboPrice: this.promotion.attributes.comboPrice,
                comboNotes: this.promotion.attributes.comboNotes,
                store: this.promotion.attributes.store.id,
                storeName: this.promotion.attributes.store.attributes.name,
                minAmount: this.promotion.attributes.store.attributes.minAmount,
                logoUrl: this.promotion.attributes.store.attributes.logoUrl,
                imageUrl: this.promotion.attributes.imageUrl,
                description: '',
                modifiers: this.selectModifiers,
                modifiersText: this.modifiersDetails(this.selectModifiers, false),
                modifiersPrice: this.selectModifiers.reduce((a, b) => { return a + b.options.reduce((c, d) => { return c + d.price}, 0) }, 0),
                deliveryCost: this.promotion.attributes.deliveryCost
            }
            
            if (window.festyTrack) window.festyTrack('add_to_cart', { currency: 'COP', value: cartItem.price * cartItem.quantity, items: [{ item_id: cartItem.product, item_name: cartItem.name, item_brand: cartItem.storeName, price: cartItem.price, quantity: cartItem.quantity }] })
      this.$store.commit("pushCart", cartItem);
            window.localStorage.setItem("cartFestyApp", JSON.stringify(this.$store.state.cart));
            window.localStorage.setItem("paymentFestyApp", JSON.stringify(this.promotion.attributes.store.attributes.payment));

            if (this.promotion.attributes.store.attributes.acceptBankTransfer && this.promotion.attributes.store.attributes.transfersMethods.length > 0) {
                window.localStorage.setItem("storePaymentsMethodsFestyApp", JSON.stringify(this.promotion.attributes.store.attributes.transfersMethods));
            }else{
                window.localStorage.setItem("storePaymentsMethodsFestyApp", JSON.stringify([]));
            }

            if (this.promotion.attributes.store.attributes.hasCardReader) {
                window.localStorage.setItem("storePaymentsHasCardReader", 1);
            }else{
                window.localStorage.setItem("storePaymentsHasCardReader", '');
            }

            this.dialogAddItems = false
        },

        modifiersDetails(modifiers, slice_text){
        let pedido_text = ''
        let pedido_text_temp = ''
        modifiers.forEach((item, indx) => {
            if (item.options) {
            item.options.forEach((option, index) => {
                pedido_text += `${option.label}`
                if (index+1 < item.options.length) {            
                pedido_text += ' | '
                }
            })

            if (indx+1 < modifiers.length) {            
                pedido_text += ' | '
                }
            }
        })

        pedido_text_temp = pedido_text

        if (slice_text) {
            pedido_text_temp = pedido_text.substring(0, 150)
            if (pedido_text.length > 150) {
            pedido_text_temp += '....'
            }
        }

        return pedido_text_temp
        },

        changeCategoryProductsStore(item) {
            if (item == "Todas") {
                this.$store.state.products = this.$store.state.all_products
            } else {
                let products = this.$store.state.all_products.filter(product => product.attributes.category === item)
                this.$store.state.products = products;
            }
        },

        getCategoriesPromos(){
            if (this.$store.state.all_products && this.$store.state.all_products.length > 0) {
                let categories = this.$store.state.all_products.map(o => o.get("name"))
                categories = Array.from(new Set(categories))
                categories = categories.filter(Boolean);
                //categories.unshift('Todas')
                this.categories = categories
            }
        },

        scrollToElement(item) {
            const el = this.$el.getElementsByClassName(item)[0];
            if (el) {
                // Use el.scrollIntoView() to instantly scroll to the element
                el.scrollIntoView({behavior: 'smooth'});
            }
        },

        getUrlSharing(id){
            return `${window.location.origin}${window.location.pathname}?id=${id}` 
        },

        openModalProductById(id){
            let product = ''
            for (let index = 0; index < this.$store.state.products.length; index++) {
                const category = this.$store.state.all_products[index];
                product = category.attributes.products.find(element => element.id == id);
                if (product) {
                    break;
                }
            }
            
            if (product) {
                this.openDialogAddItem(product)
            }
        }

        /*setColorProfilePage(img){
            if (img) {
                Vibrant.from(img).getPalette((err, palette) => {
                    //console.log(palette)
                    //this.background = palette.LightVibrant.hex
                    //this.colorText = palette.LightVibrant.bodyTextColor
                    //this.colorTextTitle = palette.LightVibrant.titleTextColor
                });
            }
        }*/
    },

}
</script>

<style lang="css">
.st { --ink:#17150E; --gray:#625E4E; --line:#E3E0D2; --bg:#F6F5EF; --red:#c91d20; --gold:#F3D923;
  background: var(--bg); color: var(--ink); font-family: 'Onest', 'Roboto', system-ui, sans-serif; min-height: 100%; padding-bottom: 96px; }
.st h1, .st h2, .st h3, .st .st-card-n { font-family: 'Bricolage Grotesque', 'Onest', sans-serif; }
.st button { font-family: inherit; cursor: pointer; }
.st button:focus-visible, .st a:focus-visible { outline: 2px solid var(--red); outline-offset: 2px; }
.st img { display: block; }
.st-wrap { max-width: 1120px; margin: 0 auto; }

/* encabezado */
.st-cover { position: relative; height: 150px; background: var(--ink); overflow: hidden; }
.st-cover img { width: 100%; height: 100%; object-fit: cover; filter: saturate(1.05); }
.st-cover-shade { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(23,21,14,.1), rgba(23,21,14,.55)); }
.st-id { position: relative; display: flex; gap: 16px; padding: 0 16px 14px; margin-top: -40px; align-items: flex-end; }
.st-logo { flex: none; width: 88px; height: 88px; border-radius: 50%; background: #fff; border: 4px solid #fff; box-shadow: 0 0 0 1px var(--line); overflow: hidden; display: grid; place-items: center; }
.st-logo img { width: 100%; height: 100%; object-fit: contain; }
.st-logo span { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 800; font-size: 34px; color: var(--gold); background: var(--ink); width: 100%; height: 100%; display: grid; place-items: center; }
.st-id-t { min-width: 0; padding-top: 44px; }
.st-name { margin: 0; font-weight: 750; font-size: 26px; letter-spacing: -.03em; line-height: 1.05; }
.st-meta { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px; }
.st-state { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; padding: 5px 11px; border-radius: 999px; background: var(--ink); color: #fff; text-transform: uppercase; letter-spacing: .04em; }
.st-state i { width: 7px; height: 7px; border-radius: 50%; background: #3DDC97; }
.st-state.closed i { background: #f87171; }
.st-pill { display: inline-flex; align-items: center; gap: 5px; min-height: 28px; padding: 0 11px; border-radius: 999px; background: #fff; border: 1px solid var(--line); font-size: 13px; font-weight: 600; color: var(--ink); }
.st-pill.btn { min-height: 44px; margin: -8px 0; }
.st-addr { margin: 8px 0 0; font-size: 13px; color: var(--gray); }
.st-id-t .st-addr + .st-addr { margin-top: 2px; }

/* pestañas */
.st-tabs { position: sticky; top: 56px; z-index: 4; background: #fff; border-top: 1px solid var(--line); border-bottom: 1px solid var(--line); }
.st-tabs-in { display: flex; gap: 8px; overflow-x: auto; padding: 10px 16px; scrollbar-width: none; }
.st-tabs-in::-webkit-scrollbar { display: none; }
.st-tab { flex: none; display: inline-flex; align-items: center; gap: 8px; min-height: 44px; padding: 0 18px; border-radius: 999px; border: 1px solid var(--line); background: #fff; color: var(--ink); font-size: 15px; font-weight: 700; }
.st-tab.on { background: var(--ink); border-color: var(--ink); color: #fff; }
.st-n { min-width: 22px; height: 22px; padding: 0 6px; box-sizing: border-box; border-radius: 999px; font-size: 12px; font-weight: 700; display: inline-grid; place-items: center; background: var(--bg); color: var(--gray); }
.st-tab.on .st-n { background: var(--gold); color: var(--ink); }

/* cuerpo */
.st-body { padding: 8px 16px 0; }
.st-group { padding-top: 26px; scroll-margin-top: 130px; }
.st-group-head { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.st-group-head h2 { margin: 0; font-weight: 750; font-size: 28px; letter-spacing: -.03em; line-height: 1.1; }
.st-note { font-size: 12px; color: var(--gray); }
.st-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin-bottom: 8px; }
.st-card { background: #fff; border: 1px solid var(--line); border-radius: 20px; overflow: hidden; display: flex; flex-direction: column; }
.st-card-img { position: relative; aspect-ratio: 4 / 3; background: #EFEDE2; overflow: hidden; }
.st-card-img img { width: 100%; height: 100%; object-fit: cover; }
.st-excl { position: absolute; top: 10px; left: 10px; background: var(--red); color: #fff; font-size: 11px; font-weight: 700; padding: 4px 9px; border-radius: 999px; text-transform: uppercase; letter-spacing: .04em; }
.st-card-b { padding: 12px 12px 12px; display: flex; flex-direction: column; gap: 6px; flex: 1; }
.st-eyebrow { font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: var(--red); }
.st-card-n { border: 0; background: none; padding: 0; text-align: left; color: var(--ink); font-weight: 700; font-size: 17px; line-height: 1.2; letter-spacing: -.01em; }
.st-desc { margin: 0; font-size: 13px; line-height: 1.35; color: var(--gray); display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.st-desc.one { -webkit-line-clamp: 1; }
.st-card-f { margin-top: auto; display: flex; align-items: center; justify-content: space-between; gap: 8px; padding-top: 4px; }
.st-price { font-weight: 700; font-size: 16px; white-space: nowrap; }
.st-price s { margin-left: 6px; font-size: 12px; font-weight: 500; color: var(--gray); }
.st-add { flex: none; width: 44px; height: 44px; border-radius: 50%; border: 1px solid var(--ink); background: #fff; color: var(--ink); font-size: 22px; line-height: 1; }
.st-add.gold { background: var(--gold); border: 0; }

.st-sub { margin-top: 18px; }
.st-sub h3 { margin: 0 0 8px; font-size: 13px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: var(--gray); }
.st-rows { display: grid; grid-template-columns: minmax(0, 1fr); gap: 8px; }
.st-row { display: flex; align-items: center; gap: 12px; background: #fff; border: 1px solid var(--line); border-radius: 16px; padding: 6px 6px 6px 14px; min-height: 56px; }
.st-row.drink { padding-left: 6px; }
.st-thumb { flex: none; width: 52px; height: 52px; border-radius: 12px; overflow: hidden; }
.st-row-t { flex: 1; min-width: 0; }
.st-row-n { border: 0; background: none; padding: 0; text-align: left; color: var(--ink); font-weight: 600; font-size: 15px; line-height: 1.25; }

.st-skel { aspect-ratio: 4 / 5; border-radius: 20px; background: #EFEDE2; animation: st-pulse 1.2s ease-in-out infinite; }
@keyframes st-pulse { 50% { opacity: .5; } }
@keyframes st-up { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) { .st * { animation: none !important; transition: none !important; } }

/* barra del pedido */
.st-cartbar-wrap { position: fixed; left: 0; right: 0; bottom: 68px; z-index: 6; display: flex; justify-content: center; padding: 0 12px; pointer-events: none; }
.st-cartbar { pointer-events: auto; width: 100%; max-width: 640px; box-sizing: border-box; background: var(--ink); color: #fff; border-radius: 20px; padding: 8px 8px 8px 18px; display: flex; align-items: center; gap: 12px; box-shadow: 0 20px 40px -14px rgba(23,21,14,.6); animation: st-up .3s ease both; }
.st-cartbar-t { flex: 1; min-width: 0; line-height: 1.25; }
.st-cartbar-n { font-weight: 700; font-size: 15px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.st-cartbar-d { font-size: 12px; color: #B4B09C; }
.st-cartbar-p { font-family: 'Bricolage Grotesque', sans-serif; font-size: 18px; }
.st-cartbar-b { border: 0; background: var(--gold); color: var(--ink); font-weight: 700; padding: 0 18px; min-height: 44px; border-radius: 12px; }

@media (min-width: 600px) {
  .st-tabs { top: 64px; }
  .st-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
  .st-rows { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .st-cover { height: 220px; }
  .st-id { padding: 0 32px 18px; margin-top: -48px; }
  .st-logo { width: 104px; height: 104px; }
  .st-id-t { padding-top: 56px; }
  .st-name { font-size: 34px; }
  .st-body { padding: 8px 32px 0; }
  .st-tabs-in { padding: 12px 32px; }
}
@media (min-width: 960px) {
  .st-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .st-cartbar-wrap { bottom: 64px; }
}

    .scroll-hide-festy::-webkit-scrollbar {
        display: none;
    }

    .v-slide-group__prev{
        display: none !important;
    }

    .share-network-facebook{
        text-decoration: none;
    }
    
    .share-network-twitter{
        text-decoration: none;
    }

    .share-network-whatsapp{
        text-decoration: none;
    }
</style>